import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function affiliateList(query?: any) {
	const queryString = formatQueryString(query);

	return await clientAxios.get(`affiliate/list${queryString}`);
}

export async function affiliateShow(affiliate_id: string) {
	return await clientAxios.get(`affiliate/${affiliate_id}/show`);
}

export async function affiliateCreate(payload: any) {
	return await clientAxios.post(`affiliate/create`, payload);
}

export async function affiliatePatch(affiliate_id: string, payload: any) {
	return await clientAxios.patch(`affiliate/${affiliate_id}/patch`, { payload });
}

export async function affiliateStatus(affiliate_id: string, status: string) {
	return await clientAxios.post(`affiliate/${affiliate_id}/status`, { status });
}

export async function affiliateDelete(affiliate_id: string) {
	return await clientAxios.del(`affiliate/${affiliate_id}/delete`);
}
